/**
 * Tiny logger that is silent in production builds.
 *
 * Use instead of console.* for diagnostics: logger.debug/info/log stay quiet
 * in production, while warn/error always pass through (they matter in prod).
 *
 *   import { logger } from '../utils/logger';
 *   logger.debug('loaded', data);
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
